import { render, staticRenderFns } from "./componentWindow.vue?vue&type=template&id=43051340&scoped=true&"
import script from "./componentWindow.vue?vue&type=script&lang=js&"
export * from "./componentWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43051340",
  null
  
)

export default component.exports